export let CURRENT_APP_VERSION = 0;

function parseSemver(version: string): { major: number; minor: number; patch: number } {
  const match = version.match(/^(\d+)\.(\d+)\.(\d+)(?:[-+].*)?$/);
  if (!match) {
    console.warn(`Invalid semver format: ${version}, using 0.0.0`);
    return { major: 0, minor: 0, patch: 0 };
  }

  return {
    major: parseInt(match[1], 10),
    minor: parseInt(match[2], 10),
    patch: parseInt(match[3], 10),
  };
}

export function setAppVersion(version: string): void {
  const { major, minor } = parseSemver(version);
  // Convert to number using bit shifting to avoid collisions
  CURRENT_APP_VERSION = (major << 16) | minor;
  console.warn(`App version: ${CURRENT_APP_VERSION}`);
}

export const clearDataMigration = (persistedState: any, version: number): any => {
  console.info(`Store version changed to ${version}, retaining persisted data`);
  // return {}; // Uncomment to clear data on version change
  return persistedState;
};

export const BigIntDevtoolsSerialize = {
  serialize: {
    replacer: (_key: any, value: unknown) => {
      if (typeof value === 'bigint') {
        return `${value}n`;
      }
      return value as any;
    },
  },
};
